import { lazy } from "react";

export const NotFoundPage = lazy(() => import("./notFoundPage"));
